var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmark = function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3D3736",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#bookmark_svg__a)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.038 6.86H5.961a3.64 3.64 0 0 0-3.628 3.628v13.253c0 1.692 1.213 2.416 2.695 1.587l4.585-2.555c.49-.268 1.283-.268 1.762 0l4.585 2.555c1.481.829 2.695.105 2.695-1.587V10.488c.011-1.995-1.622-3.628-3.617-3.628"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.666 10.488v13.253c0 1.692-1.213 2.404-2.695 1.587l-4.585-2.555c-.49-.268-1.283-.268-1.773 0l-4.585 2.555c-1.482.817-2.695.105-2.695-1.587V10.488A3.64 3.64 0 0 1 5.961 6.86h9.077a3.64 3.64 0 0 1 3.628 3.628"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.666 5.962v13.253c0 1.692-1.213 2.404-2.695 1.587l-4.305-2.404v-7.91a3.64 3.64 0 0 0-3.628-3.628H9.333v-.898a3.64 3.64 0 0 1 3.628-3.628h9.077a3.64 3.64 0 0 1 3.628 3.628"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bookmark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgBookmark;